import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10', sortable: false },
  { text: 'Nama Provider', value: 'provider_name' },
  { text: 'Nama PIC', value: 'pic_name' },
  { text: 'Jabatan', value: 'pic_job_position' },
  { text: 'No HP', value: 'pic_phone_number' },
  { text: 'Email', value: 'pic_email' },
  { text: 'Status', value: 'status', align: 'center', textAlign: 'text-center' },
  { text: 'Actions', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {
  provider_name: '',
  pic_name: '',
  pic_job_position: '',
  pic_phone_number: '',
  pic_email: '',
  status: '',
  url_callback: '',
};
